import React from 'react'
import {
  RichTextEditor,
  type RichTextEditorToolbarGroup,
} from '@enamelai/design-system'

const AUTO_REPLY_TOOLBAR: RichTextEditorToolbarGroup[] = [
  [
    'bold',
    'italic',
    'underline',
    'fontSize',
    'alignment',
    'orderedList',
    'link',
  ],
]

type MessagingAutoReplyEditorProps = {
  value: string
  disabled?: boolean
  onChange: (next: string) => void
  editorHeight?: string
}

const MessagingAutoReplyEditor = ({
  value,
  disabled = false,
  onChange,
}: MessagingAutoReplyEditorProps): React.ReactElement => {
  return (
    <RichTextEditor
      variant="sms-notes"
      value={value}
      disabled={disabled}
      placeholder=""
      toolbarGroups={AUTO_REPLY_TOOLBAR}
      bodyActions={[]}
      footerActions={[]}
      aiEnabled={false}
      onChange={(next) => {
        if (disabled) return
        onChange(next)
      }}
    />
  )
}

export default MessagingAutoReplyEditor
